module.exports = __webpack_public_path__ + "Nanny Portugal Agency Logo Blue.png?b27a6e8cb0b42de2342c77b2a13a9fd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/Nanny Portugal Agency Logo Blue.png
// module id = 99
// module chunks = 0